/*
 * @providesModule SKZLiveEventTemplate
 */

import _ from 'lodash';

export class TemplateRecord {
 id:                          string;
 name:                        string;
 entry_fee:                   number;
 total_prize:                 number;
 description:                 string;
 default_duration_minutes:    number;
 minimum_unique_participants: number;
 maximum_participants:        number;
 ticketz_prize:               number;
}

export default class LiveEventTemplate extends TemplateRecord {

  constructor(keyValueSource: Object) {
    super();
    return _.create(LiveEventTemplate.prototype, keyValueSource);
  }

  static make(templates : Array<TemplateRecord>): Array<LiveEventTemplate> {
    if (Array.isArray(templates)) {
      return _.map(templates, (templateRecord: TemplateRecord): LiveEventTemplate => new LiveEventTemplate(templateRecord));
    }
    return [];
  }
}
